export const API_CONFIG = {
  BASE_URL: process.env.REACT_APP_API_BASE_URL,
  TIMEOUT: 30000,
  SUCCESS_STATUS_CODES: [200, 201, 204],
  ERROR_MESSAGES: {
    DEFAULT: 'An error has occurred, please try again in a moment.',
    BAD_REQUEST: 'Invalid request.',
    NETWORK: 'Please check the network connection.',
    UNAUTHORIZED: 'Authentication is required.',
    FORBIDDEN: 'You do not have access.',
    NOT_FOUND: 'The resource you requested could not be found.',
    SERVER: 'A server error has occurred.',
  },
};
